import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserDefaultService } from 'src/app/shared/services/user-default.service';

@Component({
  selector: 'app-stock-cate-range',
  templateUrl: './stock-cate-range.component.html',
  styleUrls: [],
  standalone: false
})
export class StockCategoryRangeComponent implements OnInit {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor(private uds: UserDefaultService) {}

  ngOnInit(): void {
    // Apply default values only if both from and to are empty
    if (!this.from && !this.to) {
      this.uds.getDefaultStockCategory().subscribe(res => {
        if (res?.code) {
          // Set both from and to to the default category code
          this.from = res.code;
          this.to = res.code;
          // Emit the changes to notify parent components
          this.fromChange.emit(res.code);
          this.toChange.emit(res.code);
        }
      });
    }
  }
}
